//#region IMPORTS
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { updateInstoreTemplateAsync } from "../../features/instoreTemplates/instoreTemplatesSlice";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { useAppDispatch } from "../../store/configureStore";
import { toBackendDate } from "../../helpers/toBackendDate";
import agent from "../../api/agent";
//#endregion

//#region INTERFACE
interface Props {
  instoreTemplate: InstoreTemplate;
  disabled: boolean;
}
//#endregion

export default function InstoreTemplatesTableRowActionActive({
  instoreTemplate,
  disabled,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region LOGIC
  // Fast toggle active
  const instoreTemplateActiveHandler = async () => {
    const { data } = await agent.InstoreTemplates.detail(instoreTemplate.id);
    data.active = !data.active;
    data.from = toBackendDate(data.from);
    data.until = toBackendDate(data.until);
    await dispatch(updateInstoreTemplateAsync({ id: data.id, values: data }));
  };
  //#endregion

  return (
    <button
      className="flex items-center justify-center"
      disabled={disabled}
      onClick={instoreTemplateActiveHandler}
    >
      {instoreTemplate.active ? (
        <CheckCircleIcon className="h-5 w-5 text-purple-500" />
      ) : (
        <XCircleIcon className="h-5 w-5 text-gray-400" />
      )}
    </button>
  );
}
